import { observer } from 'mobx-react-lite'
import { Breadcrumbs, ContainerHeader, Typography } from 'shared/ui'
import {
  DeleteTagAction,
  RenameTagAction,
} from 'pages/settings/pages/tags/ui/TagsAction/TagsAction'
import { useTaggedContactsContext } from 'pages/settings/pages/tags/context/taggedContactsContext'
import styles from './styles.module.scss'

export const TaggedContactsPageHeader = observer(() => {
  const { tagName } = useTaggedContactsContext()

  return (
    <>
      <Breadcrumbs className={styles.breadcrumbs} />
      <ContainerHeader
        customTitle={
          <header className={styles.header}>
            <Typography variant='heading-lg' ariaLabel='Tags header'>
              {tagName}
            </Typography>
          </header>
        }
        paddingLeft={4}
        paddingRight={4}
        paddingTop={15}
        paddingBottom={23}
        style={{ minHeight: '0' }}
        actionsProps={{
          gap: 8,
          actions: [
            { iconButtonComponent: <RenameTagAction /> },
            { iconButtonComponent: <DeleteTagAction /> },
          ],
        }}
      />
    </>
  )
})
